











































































































import Vue from 'vue'

const sandboxTemplateHTML =
          `<v-tooltip-btn
            :tile="tile"
            :fab="fab"
            :rounded="rounded"
            :outlined="outlined"
            :shaped="shaped"
            :disabled="disabled"
            :depressed="depressed"
            :btnIcon="currenticon"
            :iconColor="iconColor"
            :hint="hint"
            :btnText="btnText"
            :elevation="elevation"
></v-tooltip-btn>`

export default Vue.extend({
  data: () => ({
    hint: 'This is tooltip text for my button',
    btnText: 'My button',
    tile: false,
    fab: false,
    rounded: false,
    outlined: false,
    shaped: false,
    disabled: false,
    depressed: false,
    iconColor: 'error',
    colors: ['success', 'error', 'primary'],
    icons: ['', 'mdi-close', 'mdi-check-bold', 'mdi-upload'],
    currenticon: '',
    elevation: 4,
    dark: false,

    codeSandbox: false,
    sandboxTemplate: sandboxTemplateHTML
  })
})
